//this util check if opening hours are complete

import { isEmpty, reduce } from 'lodash'

import { sortDays } from 'utils/revenueCenters'
import { DAYS_OF_WEEK } from 'resources'

export const getTransformedOperatingHours = (days) => {
  const completedDaysOfRequireDisabledKey = reduce(
    days,
    (res, day, index) => {
      if (
        isEmpty(day[0].disabled) &&
        !isEmpty(day[0].startTime) &&
        !isEmpty(day[0].endTime)
      ) {
        return {
          ...res,
          [index]: [
            {
              ...day[0],
              disabled: false,
            },
          ],
        }
      } else if (isEmpty(day[0].disabled)) {
        return {
          ...res,
          [index]: [
            {
              ...day[0],
              disabled: true,
            },
          ],
        }
      } else {
        return day[0]
      }
    },
    {}
  )

  const providedDays = Object.keys(completedDaysOfRequireDisabledKey)

  const missingDays = DAYS_OF_WEEK.filter(
    (day) => !providedDays.includes(day)
  )

  const missingDaysData = missingDays.reduce((res, day) => {
    return {
      ...res,
      [day]: [
        {
          startTime: '',
          endTime: '',
          disabled: true,
          type: 'business_hours',
        },
      ],
    }
  }, {})

  const completeDaysData = {
    ...completedDaysOfRequireDisabledKey,
    ...missingDaysData,
  }

  // data with flatten hours
  const transformedCompleteDaysData = Object.fromEntries(
    Object.entries(completeDaysData).map(([day, hours]) => [
      day,
      hours[0],
    ])
  )

  const sortedCompletedDaysData = sortDays(
    transformedCompleteDaysData
  )

  return sortedCompletedDaysData
}

export const getOperatingHoursToUpdate = (operatingHours) =>
  Object.fromEntries(
    Object.entries(operatingHours)
      .map(([day, items]) => [
        day,
        items.filter((item) => item.disabled === false),
      ])
      .filter(([day, items]) => items.length > 0)
  )
